import { Component, inject, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';
import { ITechGroupService, ITechGroupServiceToken } from 'projects/shared/lib/services/data/tech-group/tech-group-service.interface';
import { LinkComponent } from 'shared/components/shared/link/link.component';

@Component({
  selector: 'app-widget-tech-group-card-base',
  imports: [
    LinkComponent
  ],
  templateUrl: './widget-tech-group-card.component.html',
  styleUrls: ['./widget-tech-group-card-base.component.scss']
})
export class WidgetTechGroupCardBaseComponent extends WidgetBaseComponent implements OnInit {
  private readonly techGroupService: ITechGroupService = inject(ITechGroupServiceToken);

  public techGroupNumber: string | undefined;
  public imageUrl: string | undefined;
  public description: string | undefined;
  public backgroundImageStyle: string | undefined;

  public ngOnInit(): void {
    this.techGroupNumber = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("TechGroupNumber") == 0)?.value;
    this.imageUrl = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("ImageUrl") == 0)?.value;
    this.description = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Description") == 0)?.value;

    if (this.description == undefined && this.techGroupNumber != undefined) {
      this.techGroupDescriptionLoadAsync(this.techGroupNumber);
    }

    if (this.imageUrl != undefined) {
      this.backgroundImageStyle = `background-image: url("${this.imageUrl}");background-repeat: no-repeat;background-size: contain;background-position: 50% 50%;`;
    }
  }

  private async techGroupDescriptionLoadAsync(techGroupNumber: string) {
    this.techGroupService.techGroupGetAsync(techGroupNumber).then(
      (result) => {
        this.description = result.techGroup?.techGroupName;
      },
      () => { }
    );
  }
}
